module.exports = __webpack_public_path__ + "static/media/Jaclyn.640233aa.jpg";